module.exports = require('./helpers/bundle-url').getBundleURL('5992T') + "logo.5ec3ca99.svg";